import { useMutation, useQueryClient } from "react-query";
import { apiPost } from "./api";

interface BulkGenerateParams {
  jobId: number;
  hiringStageId: number;
  includedJobApplicationIds: number[];
  excludedJobApplicationIds: number[];
  roleFit: string[];
  knockoutPass: string;
  knockoutFail: string;
  knockoutNoReply: string;
  source: string[];
  hasResume: boolean | null;
  createdVia: string[];
  sort: string;
  sortDirection: string;
  rescoreRequested: boolean;
}

interface BulkGenerateResponse {
  queuedCount: number;
  skippedCount: number;
  anyTextractPending: boolean;
}

const bulkGenerateAiSummaries = async (
  params: BulkGenerateParams,
): Promise<BulkGenerateResponse> => {
  // An unset has_resume is absent from the body, not null (the backend reads absent as no filter).
  const { hasResume, ...bulkAiJobApplicationSummary } = params;
  return await apiPost({
    path: "/bulk_ai_job_application_summaries",
    variables: {
      bulkAiJobApplicationSummary: {
        ...bulkAiJobApplicationSummary,
        ...(hasResume != undefined ? { hasResume } : {}),
      },
    },
  });
};

export function useBulkGenerateAiSummaries() {
  const queryClient = useQueryClient();
  return useMutation(bulkGenerateAiSummaries, {
    onSuccess: () => {
      queryClient.invalidateQueries("jobApplicationsForStage");
      queryClient.invalidateQueries("jobApplication");
      queryClient.invalidateQueries(["organizationAiCreditBalance"]);
    },
  });
}

interface BulkGenerateAllStagesParams {
  jobId: number;
  rescoreRequested: boolean;
}

const bulkGenerateAllStagesAiSummaries = async (
  params: BulkGenerateAllStagesParams,
): Promise<BulkGenerateResponse> => {
  return await apiPost({
    path: "/bulk_ai_job_application_summaries/all_stages",
    variables: { bulkAiJobApplicationSummary: params },
  });
};

export function useBulkGenerateAllStagesAiSummaries() {
  const queryClient = useQueryClient();
  return useMutation(bulkGenerateAllStagesAiSummaries, {
    onSuccess: () => {
      queryClient.invalidateQueries("jobApplicationsForStage");
      queryClient.invalidateQueries("jobApplication");
      queryClient.invalidateQueries(["organizationAiCreditBalance"]);
      queryClient.invalidateQueries("job");
    },
  });
}
